<template>
  <div class="options is-pulled-right">
    <button
      class="button is-info is-small"
      @click="$emit('edit')"
      title="Edit the question"
    >
      Edit
    </button>
    <button
      class="button is-info is-small"
      :disabled="question.interviewMandatory"
      @click="$emit('typer')"
      title="Change the question type"
    >
      Type
    </button>
    <button
      class="button is-info is-small"
      @click="$emit('mover')"
      title="Move the question"
    >
      Move
    </button>
    <button
      class="button is-danger is-small"
      :disabled="question.interviewMandatory"
      @click="$emit('remove')"
      title="Delete the question"
    >
      Delete
    </button>
  </div>
</template>

<script>
export default {
  name: "controls",

  props: ["question"]
};
</script>

<style lang="scss" scoped></style>
